module.exports = __webpack_public_path__ + "static/house3-cb5fa8184b66a888f2d14855fa808a22.jpg";